export default {
  indicators: {
    legends: {
      newLifeInsurance: 'Assurance-vie (Nouveau)',
      lifeInsurance: 'Assurance-vie (actuel)',
      inheritedAssets: 'Actif successoral',
      precautionarySavings: 'Épargne de précaution',
    },
    titles: {
      lifeInsurance: 'Montant actuel investi en Assurance-vie',
      newLifeInsurance: 'Montant additionnel investi en Assurance-vie',
      inheritedAssets: 'Montant cumulé de l\'actif successoral',
    }
  },
  categories: {
    subtitle: 'Sélectionner pour simuler un transfert vers l\'Assurance-vie',
    sensitiveMessage: 'ℹ️  L\'arbitrage de ces actifs en assurance-vie nécessitera une étude préalable des impacts juridiques et fiscaux qu\'elle implique.'
  },
  userSelection: {
    title: 'Simuler l\'impact de l\'assurance-vie sur votre transmission :'
  },
  updateBeneficiaryClause: 'Clause bénéficiaire',
  modal: {
    title: 'Clause bénéficiaire',
    subtitle: 'Attribuer une clause bénéficiaire spécifique á la simulation',
    section: 'Choisir une clause bénéficiaire appliquée à votre simulation :',
    helpMessage: 'Pourquoi est-ce important ? Vous avez l\'opportunité de simuler une répartition différente de votre patrimoine. L\'investissement en Assurance-vie offre des avantages significatifs pour la transmission de vos actifs. La clause bénéficiaire joue un rôle clé dans l\'optimisation de votre stratégie patrimoniale.'
  },
  tooltipsMessage: 'Cette simulation a pour vocation de mettre en évidence l’impact que pourrait avoir, sur votre transmission, une part plus importante de votre patrimoine en assurance-vie. La réalisation pratique de ces opérations nécessite une étude préalable des implications juridiques et fiscales des opérations que cela implique'
}
